import React from 'react';
import ReactDOM from 'react-dom/client';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer } from 'react-toastify';
import setupInterceptors from '@/services/setupInterceptors';
import store from '@/store';
import krMsg from "./translations/kr.json";
import enMsg from "./translations/en.json";
import App from '@/App';

import './index.css';

if(process.env.NODE_ENV === 'production'){
  console.info(`
  =========================
  FRONT_VERSION : ${process.env.REACT_APP_VERSION}
  =========================\n
`)
}

const persistor = persistStore(store);

const rootNode = document.getElementById('root');

const locale = localStorage.getItem('locale') ?? 'ko';
const messages = { ko: krMsg, en: enMsg }[locale];

ReactDOM.createRoot(rootNode).render(
  <Provider store={store}>
    <BrowserRouter>
      <PersistGate persistor={persistor}>
        <IntlProvider locale={locale} messages={messages}>
          <ToastContainer />
          <App />
        </IntlProvider>
      </PersistGate>
    </BrowserRouter>
  </Provider>,
);

setupInterceptors(store);
